import { useState } from 'react';
import { useReduxState } from 'hooks';
import { Expand } from 'components/common';
import { Icon } from 'components/common/icons';

interface Props {
  children: React.ReactNode;
  title: React.ReactNode;
}

const BoxExpandable = ({ children, title }: Props) => {
  const { theme } = useReduxState();

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="box-expandable">
      <div
        className="header"
        onClick={() => setIsExpanded(!isExpanded)}
        tabIndex={0}
      >
        <div className="title">{title}</div>

        <div className="icon">
          <Icon icon="chevron-down" />
        </div>
      </div>

      <Expand isExpanded={isExpanded}>
        <div className="content">{children}</div>
      </Expand>

      <style jsx>{`
        .header {
          align-items: center;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          padding: 10px 15px;
        }
        .title {
          color: ${theme.textColorLight};
          font-size: 1.6rem;
          font-weight: 700;
          padding: 4px 0;
        }
        .icon {
          color: ${theme.textColor};
          font-size: 1.2rem;
        }
      `}</style>
    </div>
  );
};

export default BoxExpandable;
